import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { ErrorState } from "@/app/components/legacy-components";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { AppointmentCard } from "@/features/consultations/components";
import { Card, Carousel, UserHeartRoundedIcon } from "@/shared/ui";
import { tw } from "@/shared/utils";

export const UpcomingVideoConsultations = () => {
  const {
    data: upcomingAppointments,
    isError,
    isSuccess,
  } = useQuery(
    consultationsQueriesStore.consultations.appointments._ctx.list._ctx
      .upcoming,
  );

  if (!upcomingAppointments?.length) {
    return null;
  }

  return (
    <Card.Root className="p-0 sm:p-4">
      <Card.Header>
        <Card.Title icon={UserHeartRoundedIcon}>
          {t`Upcoming video consultations`}
        </Card.Title>
      </Card.Header>

      {isError && (
        <ErrorState className="justify-self-center border-transparent" />
      )}

      {isSuccess && (
        <Carousel.Root className="w-full">
          <Carousel.Content className="ml-0 flex gap-4">
            {upcomingAppointments.map((appointment) => (
              <AppointmentCard
                key={appointment.id}
                appointment={appointment}
                className={tw(
                  "max-w-11/12 min-w-11/12 sm:max-w-7/12 sm:min-w-7/12 2xl:max-w-5/12 2xl:min-w-5/12",
                  upcomingAppointments.length === 1 && "min-w-full",
                )}
              />
            ))}
          </Carousel.Content>

          <Carousel.PreviousButton />
          <Carousel.NextButton />
        </Carousel.Root>
      )}
    </Card.Root>
  );
};
